import Utils from "../utils/Utils";

export const AUTHORIZATION_RID = '1';
export const PARTNER_CONFIG_RID = Utils.getUniqNumber().toString();
export const GAME_RESULTS_RID = Utils.getUniqNumber().toString();

const AUTHORIZATION_DATA = {
  command: "request_session",
  params: {
    site_id: "900",
    language: "eng",
    aut_token: "E2300C86022F96246F4C6060DDF04A59"
  },
  rid: AUTHORIZATION_RID
}

const PARTNER_CONFIG_DATA = {
  command: "get",
  params: {
    source: "partner.config",
    what: {partner: []},
    subscribe: true,
  },
  rid: PARTNER_CONFIG_RID
};

const GAME_RESULTS_DATA = {
  command: "get_result_games",
  params: {
    is_date_ts: 1,
    sport_id: 1,
    competition_id: 1,
    from_date: 1,
    to_date: 1,
  },
  rid: GAME_RESULTS_RID,
};

const GAME_MATCH_ID_RESULT = {
  command: "get_results",
  params: {
    game_id: 1507476873,
  },
  rid: "10925654702008",
};

export {
  AUTHORIZATION_DATA, PARTNER_CONFIG_DATA, GAME_RESULTS_DATA, GAME_MATCH_ID_RESULT
};